import { CompetitorTypes } from "~enums/competitorTypes";
import type { FixtureStatuses } from "~enums/fixtureStatuses";
import type { FixtureTypes } from "~enums/fixtureTypes";
import type { Entity } from "~types/entity";
import type { FixtureResources, FixtureResponse } from "~types/fixture";
import type { Image } from "~types/image";
import type { Person } from "~types/person";
import type { AssignFixtureOfficialsTableRow } from "../types/assignFixtureOfficialsTableRow";

export const transformFixtureResponse = (seasonId: string) => (responseData: FixtureResponse) => {
  const resources: FixtureResources | undefined = responseData.includes?.resources;

  const tableData = responseData.data.map((fixture) => {
    const isPerson = fixture.competitorType === CompetitorTypes.Person;

    const competitors = fixture.competitors?.map((competitor) => {
      const { id, resourceType } = competitor.entity;
      const entity: Entity | undefined = resources?.[resourceType]?.[id];
      return {
        nameFullLocal: entity?.nameFullLocal ?? "",
        images: entity?.images ?? [],
        id: id,
        isHome: !!competitor.isHome,
      };
    });

    const participants = fixture.participants?.map((participant) => {
      const { id, resourceType } = participant.person;
      const person: Person | undefined = resources?.[resourceType]?.[id];
      return {
        nameFullLocal: person?.nameFullLocal ?? "",
        images: person?.images ?? [],
        id: id,
        isHome: !!participant.isHome,
      };
    });

    const getEntrants = (isHome: boolean, entrants: { nameFullLocal: string; isHome: boolean; images: Image[] }[]) =>
      entrants.filter((entrant) => entrant.isHome === isHome);

    const entry: AssignFixtureOfficialsTableRow = {
      fixtureId: fixture.fixtureId,
      roundNumber: fixture.roundNumber ?? "",
      awayEntrants: getEntrants(false, (isPerson ? participants : competitors) ?? []),
      homeEntrants: getEntrants(true, (isPerson ? participants : competitors) ?? []),
      venue: resources?.[fixture.venue?.resourceType ?? ""]?.[fixture.venue?.id]?.nameLocal ?? "",
      startTimeLocal: fixture.startTimeLocal,
      fixtureNumber: fixture.fixtureNumber,
      fixtureType: fixture.fixtureType as FixtureTypes,
      status: fixture.status as FixtureStatuses,
      stage: resources?.[fixture.stage?.resourceType ?? ""]?.[fixture.stage?.id]?.nameLocal ?? "",
      pool: resources?.[fixture.pool?.resourceType ?? ""]?.[fixture.pool?.id]?.nameLocal ?? "",
      series: resources?.[fixture.series?.resourceType ?? ""]?.[fixture.series?.id]?.nameLocal ?? "",
    };
    return entry;
  });

  return {
    isPersons: responseData.data[0]?.competitorType === CompetitorTypes.Person,
    tableData,
    title: resources?.seasons?.[seasonId]?.nameLocal ?? "",
  };
};
